/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MeasurementDtoDataResponse } from '../models/MeasurementDtoDataResponse';
import type { MeasurementValueDto } from '../models/MeasurementValueDto';
import type { TemplateDto } from '../models/TemplateDto';
import type { WorkbenchCalculationDto } from '../models/WorkbenchCalculationDto';
import type { WorkbenchCalculationDtoDataResponse } from '../models/WorkbenchCalculationDtoDataResponse';
import type { WorkbenchDto } from '../models/WorkbenchDto';
import type { WorkbenchDtoDataResponse } from '../models/WorkbenchDtoDataResponse';
import type { WorkbenchFilterDto } from '../models/WorkbenchFilterDto';
import type { WorkbenchFilterDtoDataResponse } from '../models/WorkbenchFilterDtoDataResponse';
import type { WorkbenchMutationDto } from '../models/WorkbenchMutationDto';
import type { WorkbenchSourceDto } from '../models/WorkbenchSourceDto';
import type { WorkbenchSourceDtoDataResponse } from '../models/WorkbenchSourceDtoDataResponse';
import type { WorkbenchSourceMutationDto } from '../models/WorkbenchSourceMutationDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WorkbenchService {

  /**
   * @returns WorkbenchCalculationDtoDataResponse OK
   * @throws ApiError
   */
  public static listWorkbenchCalculations({
    projectKey,
    workbenchId,
    after,
    before,
    first,
    last,
  }: {
    projectKey: string,
    workbenchId: string,
    after?: string,
    before?: string,
    first?: number,
    last?: number,
  }): CancelablePromise<WorkbenchCalculationDtoDataResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/calculations',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
      },
      query: {
        'after': after,
        'before': before,
        'first': first,
        'last': last,
      },
    });
  }

  /**
   * @returns WorkbenchCalculationDto OK
   * @throws ApiError
   */
  public static createWorkbenchCalculation({
    projectKey,
    workbenchId,
    requestBody,
  }: {
    projectKey: string,
    workbenchId: string,
    requestBody?: WorkbenchCalculationDto,
  }): CancelablePromise<WorkbenchCalculationDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/calculations',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns WorkbenchCalculationDto OK
   * @throws ApiError
   */
  public static getWorkbenchCalculation({
    projectKey,
    workbenchId,
    calculationId,
  }: {
    projectKey: string,
    workbenchId: string,
    calculationId: string,
  }): CancelablePromise<WorkbenchCalculationDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/calculations/{calculationId}',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
        'calculationId': calculationId,
      },
    });
  }

  /**
   * @returns WorkbenchCalculationDto OK
   * @throws ApiError
   */
  public static updateWorkbenchCalculation({
    projectKey,
    workbenchId,
    calculationId,
    requestBody,
  }: {
    projectKey: string,
    workbenchId: string,
    calculationId: string,
    requestBody?: WorkbenchCalculationDto,
  }): CancelablePromise<WorkbenchCalculationDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/calculations/{calculationId}',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
        'calculationId': calculationId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static deleteWorkbenchCalculation({
    projectKey,
    workbenchId,
    calculationId,
  }: {
    projectKey: string,
    workbenchId: string,
    calculationId: string,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/calculations/{calculationId}',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
        'calculationId': calculationId,
      },
    });
  }

  /**
   * @returns WorkbenchDtoDataResponse OK
   * @throws ApiError
   */
  public static listWorkbenches({
    projectKey,
    after,
    before,
    first,
    last,
  }: {
    projectKey: string,
    after?: string,
    before?: string,
    first?: number,
    last?: number,
  }): CancelablePromise<WorkbenchDtoDataResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/workbenches',
      path: {
        'projectKey': projectKey,
      },
      query: {
        'after': after,
        'before': before,
        'first': first,
        'last': last,
      },
    });
  }

  /**
   * @returns WorkbenchDto OK
   * @throws ApiError
   */
  public static createWorkbench({
    projectKey,
    requestBody,
  }: {
    projectKey: string,
    requestBody?: WorkbenchMutationDto,
  }): CancelablePromise<WorkbenchDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectKey}/workbenches',
      path: {
        'projectKey': projectKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns WorkbenchDto OK
   * @throws ApiError
   */
  public static getWorkbench({
    projectKey,
    workbenchId,
  }: {
    projectKey: string,
    workbenchId: string,
  }): CancelablePromise<WorkbenchDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
      },
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static updateWorkbench({
    projectKey,
    workbenchId,
    requestBody,
  }: {
    projectKey: string,
    workbenchId: string,
    requestBody?: WorkbenchMutationDto,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns WorkbenchFilterDtoDataResponse OK
   * @throws ApiError
   */
  public static listWorkbenchFilters({
    projectKey,
    workbenchId,
    after,
    before,
    first,
    last,
  }: {
    projectKey: string,
    workbenchId: string,
    after?: string,
    before?: string,
    first?: number,
    last?: number,
  }): CancelablePromise<WorkbenchFilterDtoDataResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/filters',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
      },
      query: {
        'after': after,
        'before': before,
        'first': first,
        'last': last,
      },
    });
  }

  /**
   * @returns WorkbenchFilterDto OK
   * @throws ApiError
   */
  public static createWorkbenchFilter({
    projectKey,
    workbenchId,
    requestBody,
  }: {
    projectKey: string,
    workbenchId: string,
    requestBody?: WorkbenchFilterDto,
  }): CancelablePromise<WorkbenchFilterDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/filters',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns WorkbenchFilterDto OK
   * @throws ApiError
   */
  public static getWorkbenchFilter({
    projectKey,
    workbenchId,
    filterId,
  }: {
    projectKey: string,
    workbenchId: string,
    filterId: string,
  }): CancelablePromise<WorkbenchFilterDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/filters/{filterId}',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
        'filterId': filterId,
      },
    });
  }

  /**
   * @returns WorkbenchFilterDto OK
   * @throws ApiError
   */
  public static updateWorkbenchFilter({
    projectKey,
    workbenchId,
    filterId,
    requestBody,
  }: {
    projectKey: string,
    workbenchId: string,
    filterId: string,
    requestBody?: WorkbenchFilterDto,
  }): CancelablePromise<WorkbenchFilterDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/filters/{filterId}',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
        'filterId': filterId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static deleteWorkbenchFilter({
    projectKey,
    workbenchId,
    filterId,
  }: {
    projectKey: string,
    workbenchId: string,
    filterId: string,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/filters/{filterId}',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
        'filterId': filterId,
      },
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static recalculateMeasurements({
    projectKey,
    workbenchId,
  }: {
    projectKey: string,
    workbenchId: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/RecalculateMeasurements',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
      },
    });
  }

  /**
   * @returns MeasurementValueDto OK
   * @throws ApiError
   */
  public static getMeasurementValue({
    projectKey,
    workbenchId,
    measurementValueId,
  }: {
    projectKey: string,
    workbenchId: string,
    measurementValueId: string,
  }): CancelablePromise<MeasurementValueDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/measurementValues/{measurementValueId}',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
        'measurementValueId': measurementValueId,
      },
    });
  }

  /**
   * @returns MeasurementDtoDataResponse OK
   * @throws ApiError
   */
  public static listWorkbenchMeasurements({
    projectKey,
    workbenchId,
    after,
    before,
    first,
    last,
  }: {
    projectKey: string,
    workbenchId: string,
    after?: string,
    before?: string,
    first?: number,
    last?: number,
  }): CancelablePromise<MeasurementDtoDataResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/measurements',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
      },
      query: {
        'after': after,
        'before': before,
        'first': first,
        'last': last,
      },
    });
  }

  /**
   * @returns TemplateDto OK
   * @throws ApiError
   */
  public static listTemplates({
    projectKey,
    workbenchId,
  }: {
    projectKey: string,
    workbenchId: string,
  }): CancelablePromise<Array<TemplateDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/report/templates',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
      },
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static generateCsvReport({
    projectKey,
    workbenchId,
    requestBody,
  }: {
    projectKey: string,
    workbenchId: string,
    requestBody?: Array<string>,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/report/generateCsv',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static generateReport({
    projectKey,
    workbenchId,
    templateId,
    formData,
  }: {
    projectKey: string,
    workbenchId: string,
    templateId?: string,
    formData?: {
      images?: Array<Blob>;
    },
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/report/generate',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
      },
      query: {
        'templateId': templateId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @returns WorkbenchSourceDtoDataResponse OK
   * @throws ApiError
   */
  public static listWorkbenchSources({
    projectKey,
    workbenchId,
    after,
    before,
    first,
    last,
  }: {
    projectKey: string,
    workbenchId: string,
    after?: string,
    before?: string,
    first?: number,
    last?: number,
  }): CancelablePromise<WorkbenchSourceDtoDataResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/sources',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
      },
      query: {
        'after': after,
        'before': before,
        'first': first,
        'last': last,
      },
    });
  }

  /**
   * @returns WorkbenchSourceDto OK
   * @throws ApiError
   */
  public static createWorkbenchSource({
    projectKey,
    workbenchId,
    requestBody,
  }: {
    projectKey: string,
    workbenchId: string,
    requestBody?: WorkbenchSourceMutationDto,
  }): CancelablePromise<WorkbenchSourceDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/sources',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns WorkbenchSourceDto OK
   * @throws ApiError
   */
  public static getWorkbenchSource({
    projectKey,
    workbenchId,
    sourceId,
  }: {
    projectKey: string,
    workbenchId: string,
    sourceId: string,
  }): CancelablePromise<WorkbenchSourceDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/sources/{sourceId}',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
        'sourceId': sourceId,
      },
    });
  }

  /**
   * @returns WorkbenchSourceDto OK
   * @throws ApiError
   */
  public static updateWorkbenchSource({
    projectKey,
    workbenchId,
    sourceId,
    requestBody,
  }: {
    projectKey: string,
    workbenchId: string,
    sourceId: string,
    requestBody?: WorkbenchSourceMutationDto,
  }): CancelablePromise<WorkbenchSourceDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/sources/{sourceId}',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
        'sourceId': sourceId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public static deleteWorkbenchSource({
    projectKey,
    workbenchId,
    sourceId,
  }: {
    projectKey: string,
    workbenchId: string,
    sourceId: string,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v2/projects/{projectKey}/workbenches/{workbenchId}/sources/{sourceId}',
      path: {
        'projectKey': projectKey,
        'workbenchId': workbenchId,
        'sourceId': sourceId,
      },
    });
  }

}
